/* eslint-disable no-unused-vars */
export enum Languages {
    EN = 'en',
    ZH = 'zh-Hans',
    JA = 'ja',
    KO = 'ko',
    CS = 'cs',
    DA = 'da',
    NL = 'nl',
    GB = 'en-GB',
    MX = 'es-MX',
    ES = 'es-ES',
    FR = 'fr',
    DE = 'de',
    EL = 'el',
    IT = 'it',
    TW = 'zh-Hant',
    PL = 'pl',
    PT = 'pt-PT',
    SV = 'sv'
}
/* eslint-enable no-unused-vars */